import React, { useMemo } from 'react';
import './style.scss';
import classNames from 'classnames';
import { ChangeEvent, useCallback } from 'react';

interface Props {
  name: string;
  value: string;
  placeholder?: string;
  className?: string;
  multiline?: boolean;
  error: string;
  onValueChange?: (value: string) => void;
  required?: boolean;
}

const Input: React.SFC<Props> = ({
  name,
  value,
  error,
  placeholder,
  className,
  multiline,
  onValueChange,
  required,
}) => {
  const onChange = useCallback<
    (e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void
  >((e) => onValueChange?.(e.target.value), [onValueChange]);

  const InputComponent = useMemo(
    () =>
      multiline ? (
        <div className="input__container">
          <textarea
            // prevents grammarly from working
            data-gramm="false"
            placeholder={placeholder}
            name={name}
            id={name}
            value={value}
            onChange={onChange}
            className={classNames('input__field', {
              'input__field--error': error !== '',
            })}
            required={required}
          />
          {error && <p className="input__error__text">{error}</p>}
        </div>
      ) : (
        <div className="input__container">
          <input
            // prevents grammarly from working
            data-gramm="false"
            placeholder={placeholder}
            type="text"
            name={name}
            id={name}
            value={value}
            required={required}
            onChange={onChange}
            className={classNames('input__field', {
              'input__field--error': error !== '',
            })}
          />
          {error && <p className="input__error__text">{error}</p>}
        </div>
      ),
    [error, multiline, name, onChange, placeholder, required, value]
  );

  return <div className={classNames('input', className)}>{InputComponent}</div>;
};

export default Input;
